module.exports = __webpack_public_path__ + "static/media/MainMarriage.039784e4.jpg";